<template>
  <div v-if="recommendedHalls?.length" class="mt-12 border-t border-border pt-12 md:mt-16 md:pt-16">
    <h4 class="mb-10 text-center">{{ t['w.module.product_description.product_hall']() }}</h4>
    <div class="-mx-2.5 -mb-2.5 flex flex-wrap items-center justify-center md:-mx-5">
      <RecommendedHall
        v-for="(hall, index) in recommendedHalls"
        :key="hall.id"
        :hall="hall"
        :index="index"
        :product-current-page-path="productCurrentPagePath"
        :show-icon="showIcons"
        class="mb-2.5 max-w-[180px] basis-1/2 px-2.5 text-center text-base md:px-5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import RecommendedHall from '~/components/product/RecommendedHall.vue'
import type { RecommendedHall as RecommendedHallProp } from '~/components/product/recommended-hall-type'
import * as t from '~/messages'

const { proxy: gtmProxy } = useGtm()

const props = defineProps<{
  productCurrentPagePath: string
  recommendedHalls: RecommendedHallProp[] | null
}>()

const showIcons = computed(() => {
  if (!props.recommendedHalls) {
    return false
  }

  return props.recommendedHalls.every((hall) => hall.icon)
})

const sendGtmImpression = () => {
  if (!props.recommendedHalls || props.recommendedHalls.length === 0) {
    return
  }

  gtmProxy.dataLayer.push({
    event: 'impression',
    ecommerce: {
      impressions: props.recommendedHalls.map((hall, index) => {
        return {
          name: hall.name,
          id: hall.id,
          list: 'Recommended Halls',
          position: index + 1,
        }
      }),
    },
  })
}

watch(
  () => props.recommendedHalls,
  (val, oldVal) => {
    if (!oldVal && val) {
      sendGtmImpression()
    }
  },
  {
    immediate: true,
  }
)
</script>
